import { Signal } from '@angular/core';

export abstract class FormFieldControlAdapter {
  private static nextGeneratedId = 0;

  abstract readonly id: Signal<string>;
  abstract readonly labelForId: Signal<string | null>;

  abstract setLabelledByIds(ids: string[]): void;
  abstract setDescribedByIds(ids: string[]): void;
  abstract setInvalid(isInvalid: boolean): void;
  abstract setRequired(isRequired: boolean): void;
  abstract setDisabled(isDisabled: boolean | null): void;

  focus?(): void;

  protected generateControlId(): string {
    return `form-field-control-${FormFieldControlAdapter.nextGeneratedId++}`;
  }
}
